import { Inject, Injectable, forwardRef} from '@angular/core';
import { Http, Response } from '@angular/http';

import  { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/toPromise';

import { Club } from '../../entities/club';

import { HttpClient } from './http-client.service';

import { Settings } from '../../settings';
import { DateConverter } from '../../utility/date-converter';
import { ODataBuilder } from '../../utility/odata/odata-builder';
import { ODataComparer } from '../../utility/odata/odata-comparer';

@Injectable()
export class ClubService {

  private static readonly clubBaseUrl:string = `${Settings.apiUrl}/v1/Clubs`;

  public selectedClub:Club = null;

  constructor(@Inject(forwardRef(() => HttpClient)) private http:HttpClient) { }

  getClubByOrgNodeId(orgNodeId:string):Promise<Club>{
    let oDataBuilder:ODataBuilder = new ODataBuilder(ClubService.clubBaseUrl);

    oDataBuilder.filter("OrgNodeId", ODataComparer.Equals, orgNodeId);

    let clubUrl:string = oDataBuilder.toString();

    return this.http.get(clubUrl)
      .map(response => response.json().value[0])
      .toPromise();
  }

  getClubsByNameOrRCIClubId(searchCriteria:any):Observable<Club[]>{
    let clubUrl:string = `${ClubService.clubBaseUrl}`;

    let searchInt = parseInt(searchCriteria);
    // had to manually build odata url b/c ODataBuilder automatically tries to convert the searchCriteria to a number
    // but since RotaryOrganizationId is actually type string we need leave the searchCriteria as a string in odata url
    if(Number.isInteger(searchInt)){
      clubUrl = clubUrl + `?$filter=OrgNode/RotaryOrganizationId eq '${searchCriteria}'`
    }
    else{
      clubUrl = clubUrl + `?$filter=indexof(Name, '${searchCriteria}') ne -1`
    }

    clubUrl = clubUrl + "&$expand=OrgNode&$top=15";

    return this.http.get(clubUrl)
      .map(response => response.json().value);
  }

  getClubs(searchCriteria:string = null):Promise<Club[]>{
    return this.getClubsObservable(searchCriteria).toPromise();
  }

  getClubsObservable(searchCriteria:string = null):Observable<Club[]>{
    
    let oDataBuilder:ODataBuilder = new ODataBuilder(ClubService.clubBaseUrl);

    oDataBuilder
      .top(50)
      .orderBy("Name");

    if(searchCriteria){
      oDataBuilder.filter("Name", ODataComparer.Contains, searchCriteria);
    }

    let clubUrl:string = oDataBuilder.toString();

    return this.http.get(clubUrl)
      .map(response => {
              let formattedReponse:any[] = response.json().value;

              formattedReponse.forEach(club => {
                club.MemberCountAsOfDate = DateConverter.convertDate(club.MemberCountAsOfDate)
              });

              return formattedReponse;
            });
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/services/http/club.service.ts